import React, { Suspense } from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import Loading from 'components/Loading';

const TransactionsList = React.lazy(() => import('./Transactions'));

function Transactions(props) {
  return (
    <Page>
      <PageHeader>
        <PageTitle>لیست پرداخت‌ها</PageTitle>
      </PageHeader>

      <Suspense fallback={<Loading />}>
        <TransactionsList {...props} />
      </Suspense>
    </Page>
  );
}

export default Transactions;
